import React from "react";

export function LivingBackground() {
  return (
    <div className="living-bg" aria-hidden="true">
      <div className="lb-blob lb-blob-1" />
      <div className="lb-blob lb-blob-2" />
      <div className="lb-blob lb-blob-3" />
      <div className="lb-grid" />
    </div>
  );
}
